import brandedHeaderInterrupter from './branded-header-interrupter';
import setBrandedHeader from './set-branded-header';

export default {
  brandedHeaderInterrupter,
  setBrandedHeader,
};
